import { trpc } from '@/lib/trpc';
import {
  AdminTable, AdminSectionHeader, StatusBadge,
  tdCls, exportCsv,
} from '@/components/admin/AdminShared';

const ORDER_STATUSES = ['pending', 'completed', 'refunded'] as const;

export default function AdminOrders() {
  const { data: purchases = [], refetch } = trpc.purchases.list.useQuery();

  const updateStatus = trpc.purchases.updateStatus.useMutation({
    onSuccess: () => refetch(),
  });

  const handleExport = () =>
    exportCsv(
      purchases.map(p => ({
        ID:           p.id,
        User:         (p as any).user?.name ?? '',
        Email:        (p as any).user?.email ?? '',
        Course:       (p as any).course?.title ?? '',
        Price_Paid_KD: p.pricePaid,
        Purchase_Date: new Date(p.purchaseDate).toLocaleDateString(),
        Status:       p.status,
      })),
      'mrpanadol_orders'
    );

  return (
    <div>
      <AdminSectionHeader
        title="Orders"
        count={purchases.length}
        onExport={handleExport}
      />

      <AdminTable
        headers={['User', 'Course', 'Price Paid', 'Date', 'Status', 'Update Status']}
        empty={purchases.length === 0}
      >
        {purchases.map(p => (
          <tr key={p.id} className="border-t border-white/[0.04]">

            {/* User */}
            <td className={tdCls}>
              <div className="flex items-center gap-2">
                <div className="w-7 h-7 rounded-full bg-yellow-400 flex items-center
                                justify-center text-black font-black text-xs shrink-0">
                  {((p as any).user?.name?.[0] ?? '?').toUpperCase()}
                </div>
                <div className="min-w-0">
                  <p className="text-white text-sm font-semibold truncate">
                    {(p as any).user?.name ?? '—'}
                  </p>
                  <p className="text-[#52525B] text-xs truncate">
                    {(p as any).user?.email ?? ''}
                  </p>
                </div>
              </div>
            </td>

            {/* Course */}
            <td className={tdCls}>
              <p className="text-[#E4E4E7] text-sm max-w-[200px] truncate">
                {(p as any).course?.title ?? '—'}
              </p>
            </td>

            {/* Price paid */}
            <td className={`${tdCls} text-yellow-400 font-black whitespace-nowrap`}>
              {parseFloat(p.pricePaid as string) === 0 ? 'Free' : `${p.pricePaid} KD`}
            </td>

            {/* Date */}
            <td className={`${tdCls} text-[#71717A] text-xs whitespace-nowrap`}>
              {new Date(p.purchaseDate).toLocaleDateString()}<br />
              <span className="text-[#3F3F46]">
                {new Date(p.purchaseDate).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
              </span>
            </td>

            {/* Status badge */}
            <td className={tdCls}>
              <StatusBadge status={p.status} />
            </td>

            {/* Update status dropdown */}
            <td className={tdCls}>
              <select
                value={p.status}
                onChange={e => {
                  const newStatus = e.target.value as typeof ORDER_STATUSES[number];
                  if (newStatus !== p.status) {
                    updateStatus.mutate({ id: p.id, status: newStatus });
                  }
                }}
                className="mp-card text-[#E4E4E7]
                           text-xs rounded-lg px-3 py-2 outline-none
                           focus:border-yellow-400/40 cursor-pointer"
              >
                {ORDER_STATUSES.map(s => (
                  <option key={s} value={s}>{s}</option>
                ))}
              </select>
            </td>
          </tr>
        ))}
      </AdminTable>
    </div>
  );
}
